// extracted by mini-css-extract-plugin
export default {"fullWidth":"Gm-z","image":"Hm-z","lazyLoadPicture":"Im-z","lazyLoadSpinner":"Jm-z","lazyLoadSpin":"Km-z","lazyLoadImage":"Lm-z","hasStyledAspectRatio":"Mm-z"};